import { graphql, Link, useStaticQuery } from 'gatsby';
import { useShowPreOrderVariants } from 'gatsby-theme-hem-store/src/hooks/useShowPreOrderVariants';
import React from 'react';

type Props = {
  onClick?: () => void;
};

export const MainMenuPreOrderLink: React.FC<Props> = ({ onClick }) => {
  const shouldShow = useShowPreOrderVariants();
  const data = useStaticQuery<Queries.HowManyPreOrderProductVariantsQuery>(
    graphql`
      query HowManyPreOrderProductVariants {
        allContentfulProductVariant(
          filter: {
            id: { ne: null }
            sku: { ne: null }
            slug: {
              regex: "/^((?!(kitchen-sink|do-not-delete)).)*$/s"
              ne: null
            }
            variantName: { ne: null }
            productName: { ne: null }
            primarySubcategory: { slug: { ne: null } }
            shopify: { id: { ne: null } }
            product: { id: { ne: null } }
            airtable: {
              id: { ne: null }
              product: { id: { ne: null } }
              status: { eq: "Pre-order" }
            }
          }
        ) {
          totalCount
        }
      }
    `,
  );

  if (!shouldShow || data.allContentfulProductVariant.totalCount === 0) {
    return null;
  }

  return (
    <li>
      <Link
        to="/coming-soon"
        className="text-black group block items-center gap-2 py-1 text-lg font-bold"
        onClick={onClick}
      >
        Coming soon
      </Link>
    </li>
  );
};
